import React, { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ExpansiveSideNavigation from './ExpansiveSideNavigation/ExpansiveSideNavigation';
import './mobile-navigation.scss';

interface MobileNavigationProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileNavigation: FC<MobileNavigationProps> = ({ isOpen, onClose }) => {
  const location = useLocation();
  const initialLocation = useRef(location.pathname + location.search);

  // Close when navigation happens (user clicked a link)
  useEffect(() => {
    const currentLocation = location.pathname + location.search;
    if (isOpen && currentLocation !== initialLocation.current) {
      onClose();
    }
  }, [location, isOpen, onClose]);

  // Update initial location when drawer opens
  useEffect(() => {
    if (isOpen) {
      initialLocation.current = location.pathname + location.search;
    }
  }, [isOpen, location]);

  return (
    <div className={`mobile-navigation-overlay${isOpen ? ' open' : ''}`}>
      <div className='mobile-navigation-backdrop' onClick={onClose} />
      <div
        className='mobile-navigation'
        onClick={(e) => {
          const target = (e.target as HTMLElement).closest('a');
          if (target) onClose();
        }}
      >
        <ExpansiveSideNavigation />
      </div>
    </div>
  );
};

export default MobileNavigation;
